import React from 'react'

import { TelephoneService } from '~/gql/graphql'

import styles from './styles.module.css'

const PhoneContent = ({ telephone }: { telephone: TelephoneService }) => {
  const { inclusiveCalls } = telephone

  const inclusiveCallTypes = (value: string) =>
    ({
      evenings_and_weekends: 'evening and weekend calls.',
      weekends: 'weekend calls.',
      anytime: 'anytime calls.'
    }[value])

  return (
    <div className={styles.sections} data-has-border>
      <h6 className={styles.header}>{`What's included`}</h6>
      <p className={styles.sectionBody} data-large-body>
        Includes <strong>{inclusiveCallTypes(inclusiveCalls)}</strong>
      </p>
      <p className={styles.sectionBody} data-large-body>
        Check the provider’s website for call charges at other times.
      </p>
    </div>
  )
}

export default PhoneContent
